import { useCallback } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { BaseNavbarPage, ScanDocument } from "scandoc-react-components";
import styles from "./ScanPage.module.css";
//
function ScanPage() {
	const navigate = useNavigate();
	const { hotelID } = useParams();
	const [searchParams] = useSearchParams();
	const { state } = useLocation();

	const expectedName = state?.expectedGuest?.Name;
	const expectedSurname = state?.expectedGuest?.Surname;
	const reservationMode = state?.reservationMode;

	const onExtractedResults = useCallback(
		(data) =>
			navigate(`/result?${searchParams}`, {
				state: {
					hotelID: hotelID,
					results: data,
					expectedGuest: state?.expectedGuest || null,
          			reservationMode: reservationMode || null,
				},
			}),
		[navigate, hotelID, searchParams]
	);

	return (
		<BaseNavbarPage>
		{expectedName ? (
		  <div className={styles.scanGuestText}>
			Scan Guest: {[expectedName, expectedSurname].filter(Boolean).join(" ")}
			{reservationMode ? (
			  <span className={styles.guestCount}>
				({reservationMode.index + 1}/{reservationMode.guests.length})
			  </span>
			) : null}
		  </div>
		) : null}
		<ScanDocument onStepComplete={onExtractedResults} />
	  </BaseNavbarPage>
	);
}

export default ScanPage;
